import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const campo = 'w-full bg-[#050505] border border-[#2D243F] rounded-md px-4 py-3 text-white text-lg focus:border-[#E2B84A] focus:ring-1 focus:ring-[#E2B84A] outline-none transition-all';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', senha: '' });
  const [forgotOpen, setForgotOpen] = useState(false);
  const [passo, setPasso] = useState('email');
  const [forgotEmail, setForgotEmail] = useState('');
  const [codigo, setCodigo] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [aviso, setAviso] = useState('');

  const abrirEsqueci = () => {
    setForgotOpen(true); setPasso('email'); setForgotEmail(formData.email);
    setCodigo(''); setNovaSenha(''); setAviso('');
  };

  const pedirCodigo = async (e) => {
    e.preventDefault();
    if (!forgotEmail.trim()) return;
    setForgotLoading(true); setAviso('');
    try {
      const r = await axios.post(API_URL + '/api/auth/forgot-password', { email: forgotEmail.trim().toLowerCase() });
      setAviso(r.data.message || ''); setPasso('codigo');
    } catch (err) {
      toast.error((err.response && err.response.data && err.response.data.detail) || 'Confira o e-mail digitado');
    } finally { setForgotLoading(false); }
  };

  const criarSenha = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    try {
      await axios.post(API_URL + '/api/auth/reset-password', { email: forgotEmail.trim().toLowerCase(), codigo: codigo, nova_senha: novaSenha });
      setFormData({ email: forgotEmail.trim().toLowerCase(), senha: novaSenha });
      setPasso('ok');
    } catch (err) {
      toast.error((err.response && err.response.data && err.response.data.detail) || 'Não foi possível criar a senha');
    } finally { setForgotLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(formData.email, formData.senha);
    if (result.success) {
      toast.success('Login realizado com sucesso!');
      navigate('/curso/aluno');
    } else {
      toast.error(result.error || 'Erro ao fazer login');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-32 h-32 mx-auto mb-6 object-contain" />
          <h1 className="text-4xl font-black text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Bem-vindo(a) de volta</h1>
          <p className="text-[#A19BAA]" style={{ fontFamily: 'Manrope, sans-serif' }}>Acesse sua conta Giraia Bike Shop</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#120E1A] border border-[#2D243F] rounded-xl p-8" data-testid="login-form">
          <div className="mb-6">
            <label className="block text-white font-medium mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>Email</label>
            <input type="email" required data-testid="login-email-input" value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })} className={campo} placeholder="seu@email.com" />
          </div>
          <div className="mb-6">
            <label className="block text-white font-medium mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>Senha</label>
            <input type="password" required data-testid="login-password-input" value={formData.senha}
              onChange={(e) => setFormData({ ...formData, senha: e.target.value })} className={campo} placeholder="Sua senha" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-button"
            className="w-full bg-[#E2B84A] text-[#141118] font-bold text-lg rounded-lg px-6 py-3 hover:bg-[#F0D98C] transition-colors disabled:opacity-50">
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
          <div className="mt-6 text-center">
            <p className="text-[#A19BAA]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Quer fazer o curso de scooter?{' '}
              <Link to="/curso/gratis" className="text-[#E2B84A] font-semibold" data-testid="login-register-link">Comece pela aula grátis</Link>
            </p>
          </div>
          <div className="mt-4 text-center">
            <button type="button" onClick={abrirEsqueci} data-testid="forgot-password-link" className="text-[#E2B84A] text-base font-bold underline">
              Esqueci minha senha
            </button>
          </div>
          <div className="mt-4 text-center">
            <Link to="/" className="text-[#716A80] hover:text-[#A19BAA] text-sm" data-testid="login-home-link">← Voltar para a loja</Link>
          </div>
        </form>
      </div>

      {forgotOpen && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setForgotOpen(false)}>
          <div className="bg-[#120E1A] border-2 border-[#E2B84A] rounded-2xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-2xl font-black text-white mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Criar uma senha nova</h3>

            {passo === 'email' && (
              <form onSubmit={pedirCodigo}>
                <p className="text-[#A19BAA] mb-4">Digite o e-mail da sua conta. Vamos mandar um código de 6 números para ele.</p>
                <input type="email" required value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="seu@email.com" data-testid="forgot-email-input" className={campo + ' mb-4'} />
                <button type="submit" disabled={forgotLoading} data-testid="forgot-submit"
                  className="w-full bg-[#E2B84A] text-[#141118] font-black text-lg rounded-lg py-3 disabled:opacity-60">
                  {forgotLoading ? 'Enviando...' : 'Mandar código'}
                </button>
              </form>
            )}

            {passo === 'codigo' && (
              <form onSubmit={criarSenha}>
                <p className="text-[#A19BAA] mb-4">{aviso}</p>
                <label className="block text-white font-medium mb-2">Código de 6 números</label>
                <input inputMode="numeric" maxLength={6} required value={codigo} onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ''))}
                  placeholder="000000" className={campo + ' mb-4 text-center text-2xl tracking-[0.5em]'} />
                <label className="block text-white font-medium mb-2">Senha nova (pelo menos 6 letras ou números)</label>
                <input type={mostrar ? 'text' : 'password'} required minLength={6} value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)}
                  className={campo + ' mb-2'} />
                <label className="flex items-center gap-2 text-[#A19BAA] mb-4">
                  <input type="checkbox" checked={mostrar} onChange={(e) => setMostrar(e.target.checked)} /> Mostrar senha
                </label>
                <button type="submit" disabled={forgotLoading}
                  className="w-full bg-[#E2B84A] text-[#141118] font-black text-lg rounded-lg py-3 disabled:opacity-60">
                  {forgotLoading ? 'Salvando...' : 'Criar senha nova'}
                </button>
                <button type="button" onClick={() => setPasso('email')} className="w-full text-[#A19BAA] underline mt-3">Não chegou? Mandar de novo</button>
              </form>
            )}

            {passo === 'ok' && (
              <div className="text-center">
                <p className="text-green-300 text-lg font-bold mb-4">✅ Senha nova criada!</p>
                <button onClick={() => setForgotOpen(false)} className="w-full bg-[#E2B84A] text-[#141118] font-black text-lg rounded-lg py-3">
                  Entrar agora
                </button>
              </div>
            )}

            {passo !== 'ok' && (
              <button type="button" onClick={() => setForgotOpen(false)} className="w-full text-[#716A80] mt-4">Cancelar</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
